import { GeoJsonProperties } from 'geojson';
import Supercluster from 'supercluster';

// Supercluster options for marker clustering
export const superclusterOptions: Supercluster.Options<GeoJsonProperties, Record<string, unknown>> = {
  // The tile extent. Radius is calculated as: Math.pow(2, zoom) * extent / 256
  // Higher values create larger clusters but may reduce performance
  // Reduced to 256 for tighter, more precise clusters
  extent: 256,

  // The radius of each cluster in pixels. Markers within this radius will be grouped together
  // Smaller values create more precise clusters, larger values group more markers
  // Reduced to 200 for tighter clustering with more precise grouping
  radius: 200,

  // The maximum zoom level at which clusters are generated
  // Clusters will be broken down into individual markers at this zoom level
  maxZoom: 20,

  // The minimum zoom level at which clusters are generated
  // Below this zoom level, all markers will be shown as individual points
  minZoom: 0,

  // Size of the KD-tree leaf node. Affects performance and memory usage
  // Higher values use more memory but may be faster for large datasets
  nodeSize: 64
};
